<template>
  <div>
    <ToolbarAuth />
    <div v-if="saving">
      <saving />
    </div>
    <div class="mt-15 ml-15 mr-15">
      <v-card class="mb-15">
        <v-row no-gutters>
          <v-col cols="12">
            <h3 class="primary--text ma-8">Rapportages {{ bv_planSingle.first_name_client }} {{ bv_planSingle.last_name_client }} voor {{ bv_planSingle.name_company }}</h3>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left text-uppercase" width="400px">Rapportage</th>
                <th class="text-left text-uppercase" width="25px">Formeel</th>
                <th class="text-left text-uppercase">Informeel</th>
                <!--                  <th class="text-left text-uppercase" width="150px"></th>-->
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ondernemer</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="aPrint" color="accent" v-bind="attrs" v-on="on" :disabled="disableBtn"> mdi-printer </v-icon>
                    </template>
                    <span class="text-uppercase"> {{ $t("crud.print") }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="aPrintInf" color="primary" v-bind="attrs" v-on="on" :disabled="disableBtn"> mdi-printer </v-icon>
                    </template>
                    <span class="text-uppercase"> {{ $t("crud.print") }}</span>
                  </v-tooltip>
                </td>
              </tr>
              <tr>
                <td>Waarnemer / Opvolger</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="bPrint" color="accent" v-bind="attrs" v-on="on" :disabled="disableBtn"> mdi-printer </v-icon>
                    </template>
                    <span class="text-uppercase"> {{ $t("crud.print") }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="bPrintInf" color="primary" v-bind="attrs" v-on="on" :disabled="disableBtn"> mdi-printer </v-icon>
                    </template>
                    <span class="text-uppercase"> {{ $t("crud.print") }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import saving from "@/components/saving";
import NplanBvService from "@/services/nplan/NplanBvService";

export default {
  name: "Users",
  components: {
    ToolbarAuth,
    saving,
  },
  data() {
    return {
      disableBtn: false,
      saving: false,
      user_id: null,
    };
  },
  methods: {
    closeView() {
      this.$router.replace({ name: "bvIndex" });
    },
    aPrint() {
      this.disableBtn = true;
      this.name = "Rapport_" + this.bv_planSingle.last_name_client + ".docx";
      // eslint-disable-next-line no-undef
      EventBus.$emit("print", true);
      let id = this.$route.params.id;
      NplanBvService.getReportFormalA(id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.name);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.disableBtn = false;
        });
    },

    aPrintInf() {
      this.disableBtn = true;
      this.name = "Rapport_" + this.bv_planSingle.last_name_client + ".docx";
      // eslint-disable-next-line no-undef
      EventBus.$emit("print", true);
      let id = this.$route.params.id;
      NplanBvService.getReportInFormalA(id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.name);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.disableBtn = false;
        });
    },


    bPrint() {
      this.disableBtn = true;
      this.name = "Rapport_waarnemer_" + this.bv_planSingle.last_name_client + ".docx";
      // eslint-disable-next-line no-undef
      EventBus.$emit("print", true);
      let id = this.$route.params.id;
      NplanBvService.getReportFormalB(id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.name);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.disableBtn = false;
        });
    },
    bPrintInf() {
      this.disableBtn = true;
      this.name = "Rapport_waarnemer_" + this.bv_planSingle.last_name_client + ".docx";
      // eslint-disable-next-line no-undef
      EventBus.$emit("print", true);
      let id = this.$route.params.id;
      NplanBvService.getReportInFormalB(id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.name);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.disableBtn = false;
        });
    },
  },
  computed: {
    ...mapGetters("bvSingle", ["loading", "error", "bv_planSingle"]),
  },
  created() {
    let ClientId = this.$route.params.id;
    this.$store.dispatch("bvSingle/getBVplan", ClientId);
  },
};
</script>

<style scoped></style>
